import { useEffect, useRef, useState } from 'react';

import { Box, Dialog, DialogContent } from '@mui/material';

import { MetaTags } from '@redwoodjs/web';

import ModalContent from 'src/components/ModalContent/ModalContent';
import { Step, StepperComponent } from 'src/components/StepperComponent/StepperComponent';
import { ADD_PARTNER_STEPS } from 'src/constants/partners';
import { useAddPartnerContext } from 'src/contexts/AddPartnerProvider';
import { PageContent } from 'src/layouts/MainLayout/PageContent';

const AddPartnerPage = () => {
    const [isDraftApplicationAvailable, setIsDraftApplicationAvailable] = useState<boolean>(false);

    const {
        deletePartnerApplication,
        queryPartnerApplication,
        getAccountManagers,
        setApplication,
        findingDraftPartnerApplication,
        draftAvailable,
        steps,
        setActiveStep,
        activeStep,
        setSteps,
    } = useAddPartnerContext();

    const showDraftApplicationAvailableModal = useRef(false);

    useEffect(() => {
        getAccountManagers();
        queryPartnerApplication();
    }, []);

    useEffect(() => {
        if (!showDraftApplicationAvailableModal.current && draftAvailable) {
            setIsDraftApplicationAvailable(true);
            showDraftApplicationAvailableModal.current = true;
        }
    }, [draftAvailable]);

    // Scroll to the start of the new form
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activeStep]);

    return (
        <PageContent>
            <MetaTags title="AddPartner" description="AddPartner page" />
            <Box
                sx={{ width: '100%', padding: '24px 0px' }}
                display="flex"
                flexDirection="column"
                gap="24px"
            >
                <StepperComponent
                    stepsList={steps}
                    activeStep={activeStep}
                    showStepLabel={false}
                    setActiveStep={setActiveStep}
                />

                {steps?.[activeStep]?.form}
            </Box>
            {/* Second Dialog for draft applications */}
            {!findingDraftPartnerApplication && activeStep > 0 && (
                <Dialog
                    open={isDraftApplicationAvailable}
                    onClose={() => setIsDraftApplicationAvailable(false)}
                    aria-labelledby="show-draft-partner-dialog-notif"
                    sx={{
                        '& .MuiDialog-paper': {
                            width: '400px',
                        },
                    }}
                >
                    <DialogContent>
                        <ModalContent
                            handleClose={() => setIsDraftApplicationAvailable(false)}
                            handleAction={async () => {
                                await deletePartnerApplication();
                                setApplication(null);
                                setIsDraftApplicationAvailable(false);
                                setActiveStep(0);
                                setSteps(
                                    ADD_PARTNER_STEPS.map((step: Step) => {
                                        step.completed = false;
                                        return step;
                                    })
                                );
                            }}
                            closeModalButtonText="Continue Application"
                            isEdit
                            header="We found an incomplete Partner application"
                            message={
                                'Would you like to continue with the last application or start a new one?'
                            }
                            buttonText="Start New Application"
                        />
                    </DialogContent>
                </Dialog>
            )}
        </PageContent>
    );
};

export default AddPartnerPage;
